define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/xml",
	"Apparel/MaterialRefMixin"
], function(declare,Ref,xml,MaterialRefMixin) {

	return declare([Ref, MaterialRefMixin], {
		_addFilters: function(/*Context*/ctx, /*Query*/q) {
			// summary: return filters for selecting materials
			var root = ctx.getNode(ctx.view.urlRoot);
			var product = ctx.cache.getPathNode(root, "Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__/Child:__Parent__")

			if (product) {
				if (product.$Type == "Style") {
					q.Attr2("MaterialUsage", xml.OP_EQUALS, {
						Path: "Child:ProductType/Child:ProductionConfig",
						SValue: "MaterialUsage:Standalone"
					});
				} else {
					q.Attr2("MaterialUsage", xml.OP_NOT_EQUALS, {
						Path: "Child:ProductType/Child:ProductionConfig",
						SValue: "MaterialUsage:Tool"
					});
				}
			}
			q.Attr("Special", xml.OP_EQUALS, false);
		}
	});
});
